import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Hide, Absolute, Button } from 'pcln-design-system'
import { format } from 'date-fns'
import { Departure as DepartureIcon, Arrival as ArrivalIcon, Calendar, Close } from 'pcln-icons'
import { ArrowSpinButton } from '@pcln/fly-ui-components'
import FlyLocationTypeahead from '../FlyLocationTypeahead'
import DatePickerInput from '../DatePickerInput'
import { BorderBox } from './Slice.styles'

const Slice = ({
  slice,
  swapSlices,
  tripType,
  airports,
  setAirports,
  index,
  removeSlice,
  cabinClass,
  updateSlice,
  pclnExpt,
  validationError
}) => {
  const addAirport = (airport) => {
    const updatedAirports = { ...airports }
    updatedAirports[airport.id] = airport
    setAirports(updatedAirports)
  }
  const updateOrigin = (val) => {
    addAirport(val)
    updateSlice(index, 'origAirportCode', val?.id)
  }
  const updateDest = (val) => {
    addAirport(val)
    updateSlice(index, 'destAirportCode', val?.id)
  }
  const setDate = (val) => {
    updateSlice(index, 'date', format(val.startDate, 'yyyyMMdd'))
    if (val.endDate) {
      updateSlice(index, 'returnDate', format(val.endDate, 'yyyyMMdd'))
    }
  }

  return (
    <Flex alignItems='center' flexDirection={['column', null, null, null, 'row']}>
      <Box
        width={1}
        mb={[3, null, null, null, 0]}
        mr={tripType === 'MD' ? [0, null, null, null, 2] : 0}
        data-testid={`origin-airport-${slice.origAirportCode}`}
      >
        <FlyLocationTypeahead
          icon={<DepartureIcon color='primary' size={24} />}
          id={`origin-input-${index}`}
          data-selenium={'origin-input'}
          className='origin-input'
          onChange={updateOrigin}
          airportCode={slice.origAirportCode}
          airports={airports}
          aria-label={'Where from?'}
          errorMessage={null}
          placeholder={'Where from?'}
          showNearbyAirports={false}
        />
      </Box>
      {tripType === 'MD' ? null : (
        <Hide xs sm md lg>
          <Box mx={2} data-testid='swap-button'>
            <ArrowSpinButton
              description={'Swap Origin and Destination'}
              identifier={'swap-button'}
              onClick={swapSlices}
              borderRadius={'md'}
            />
          </Box>
        </Hide>
      )}
      <Box
        width={1}
        mb={[3, null, null, null, 0]}
        data-testid={`destination-airport-${slice.destAirportCode}`}
      >
        <FlyLocationTypeahead
          icon={<ArrivalIcon color='primary' size={24} />}
          id={`destination-input-${index}`}
          data-selenium={'destination-input'}
          className='destination-input'
          onChange={updateDest}
          airportCode={slice.destAirportCode}
          airports={airports}
          placeholder={'Where to?'}
          aria-label={'Where to?'}
          errorMessage={!slice.destAirportCode && validationError && index === 1 && 'Please Enter a Destination'}
        />
      </Box>
      <BorderBox
        width={1}
        color='background.lightest'
        mb={[3, null, null, null, 0]}
        ml={[0, null, null, null, 2]}
        borderRadius={'lg'}
      >
        <Absolute left={4} top={10}>
          <Calendar color='primary' />
        </Absolute>
        <DatePickerInput
          pl='2px'
          onChange={setDate}
          isRoundTrip={tripType === 'RT'}
          startDate={slice.date}
          endDate={tripType === 'RT' ? slice.returnDate : null}
          tripType={tripType}
          airportsArray={[airports?.[slice?.origAirportCode], airports?.[slice?.destAirportCode]]}
          ismd={tripType === 'MD'}
          isLastSlice={false}
          cabinClass={cabinClass}
          pclnExpt={pclnExpt}
        />
      </BorderBox>
      {tripType === 'MD' && index > 0 ? (
        <Hide xs sm md lg>
          <Button
            p={2}
            mr='-46px'
            color='background.light'
            data-testid={`remove-slice-${index}`}
            onClick={() => {
              removeSlice(index)
            }}
          >
            <Close size={30} color='primary.base' />
          </Button>
        </Hide>
      ) : null}
    </Flex>
  )
}
Slice.propTypes = {
  slice: PropTypes.object,
  setTripSlices: PropTypes.func,
  tripType: PropTypes.string,
  airports: PropTypes.object,
  setAirports: PropTypes.func,
  index: PropTypes.number,
  removeSlice: PropTypes.func,
  swapSlices: PropTypes.func,
  cabinClass: PropTypes.string,
  updateSlice: PropTypes.func,
  pclnExpt: PropTypes.any,
  validationError: PropTypes.bool,
}

export { Slice }
